import { kernelStorageClient } from "../../../../../api/services";
import { CorgiModeActionKey } from "../../../actions/ActionKeys";
import { CorgiModeAction } from "../../../actions/corgiMode";

const persistedCorgiMode : boolean = kernelStorageClient.readCorgiMode();

/** The corgi mode redux state (also persisted to local storage). */
export const corgiModeEnabled = (
  state: boolean = persistedCorgiMode,
  action: CorgiModeAction
): boolean => {
  switch (action.type) {
    case CorgiModeActionKey.SET_CORGI_MODE:
      return action.payload.enabled;
    default:
      return state;
  }
};
